'use strict';

module.exports = angular.module('ui.utils.masks', [
	require('./global/global-masks'),
	require('./br/br-masks'),
	require('./us/us-masks'),
	require('./ch/ch-masks')
]).name;



//////////////////
// WEBPACK FOOTER
// ./~/angular-input-masks/src/angular-input-masks.js
// module id = 856
// module chunks = 1